import MasterIndex from './master-index';

export default class MasterIndexDesktop extends MasterIndex {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/master/master-index.desktop.js